import { isAxiosError } from "axios";
import { VIEW_ONLY_WRITE_REFUSAL_MESSAGE } from "@common/userWorkspaceRoles";

/**
 * The single toast slot the view-only refusal shares, so a bulk fan-out of
 * requests (or a click-time refusal landing next to a 403) shows the sentence
 * once instead of stacking N identical toasts.
 */
export const VIEW_ONLY_TOAST_KEY = "view-only-write-refusal";

/**
 * True when an error is the backend's view-only 403, identified by its body
 * message. The shared conditional every view-only-aware handler reuses so the
 * detection lives in one place (PRO-11491).
 */
export function isViewOnlyRefusalError(error: unknown): boolean {
    return (
        isAxiosError(error) &&
        error.response?.data?.message === VIEW_ONLY_WRITE_REFUSAL_MESSAGE
    );
}
